import { ActivityIndicator, FlatList, Pressable, View, useDripsyTheme } from 'dripsy';
import { t } from 'i18next';
import React, { useState } from 'react';

import { keyGenerator } from '@/utils/keyGenerator';
import { Icon } from '@/design-system/components/icons/Icon';
import { UniInput } from '@/design-system/components/inputs';
import { useNativeModalView } from '@/design-system/components/modal/nativeModal/useNativeModalView';
import { TextBody, TextSmall, TextTitle } from '@/design-system/components/typography';
import { PageHeaderModalNative } from '../../../account-management/screens/page/PageHeaderModalNative';
import { UniIconButton } from '@/design-system/components/buttons';
import { useAccounts } from '../../hooks/useCardAccounts.hook';
import { debounce } from 'lodash';

export interface SelectAccountNativeScreenProps {
  onSelect: (data: any) => void;
}

export const SelectAccountNativeScreen: React.FC<SelectAccountNativeScreenProps> = (props) => {
  const { onSelect } = props;
  const { theme } = useDripsyTheme();

  const { handleBack, animatedStyle } = useNativeModalView({});

  const onSelectWallet = (data: any) => {
    onSelect(data);
    handleBack();
  };

  const [search, setSearch] = useState('');
  const { accounts, isLoading } = useAccounts({ pageSize: 10, search });

  return (
    <View sx={{ backgroundColor: '$backgroundPrimary', width: '100%', height: '100%' }}>
      <PageHeaderModalNative>
        <View sx={{ px: '$4', my: '$5' }}>
          <View sx={{ position: 'absolute', top: 0, left: 12, zIndex: 2 }}>
            <UniIconButton icon="arrowLeft" options={{ iconStyles: { themeColor: '$white' } }} onPress={() => handleBack()}></UniIconButton>
          </View>
          <View sx={{ textAlign: 'center', width: '100%' }}>
            <TextTitle bold sx={{ color: '$white' }}>
              {t('earn-invest::glossary.select-account')}
            </TextTitle>
          </View>
          <View sx={{ position: 'absolute', top: 0, right: 12, zIndex: 2 }}></View>
        </View>
      </PageHeaderModalNative>
      <View sx={{ paddingX: '$4', paddingY: '$3' }}>
        <UniInput
          prefixIcon="search"
          wrapperSx={{ flex: 1 }}
          sx={{ width: '100%' }}
          onValueChange={debounce((value) => setSearch(value || ''), 1000)}
          placeholder={t('card-account::credit-card-new-account.glossary.search-by-name')}
        />
      </View>
      <View sx={{ height: 'auto' }}>
        {!isLoading ? (
          accounts.length > 0 ? (
            <FlatList
              data={accounts}
              keyExtractor={(item) => keyGenerator('accountSelector')}
              renderItem={({ item }) => (
                <Pressable
                  sx={{
                    paddingX: '$4',
                    paddingY: '$2',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    backgroundColor: 'transparent'
                  }}
                  onPress={() => onSelectWallet(item)}>
                  <View sx={{ pt: '$3', pb: '$1' }}>
                    <TextSmall semiBold sx={{ color: '$secondary' }}>
                      {item?.name || ' - '}
                    </TextSmall>
                    <TextSmall sx={{ color: '$textSecondary' }}>{item.accountNumber}</TextSmall>
                  </View>
                </Pressable>
              )}
            />
          ) : (
            <View sx={{ flex: 1, height: '100%', paddingX: '$4', paddingY: '$3', justifyContent: 'center', alignItems: 'center' }}>
              <Icon name="listZeroState" height={60} width={60} />
              <TextBody bold sx={{ textAlign: 'center', marginTop: '$3' }}>
                {t('earn-invest::glossary.no-accounts-found')}
              </TextBody>
            </View>
          )
        ) : (
          <View sx={{ padding: '$5' }}>
            <ActivityIndicator size="large" color={(theme.colors?.$disable as string) || '#F0F0F0'} />
          </View>
        )}
      </View>
    </View>
  );
};
